import React from 'react'
import { FormFill } from '../FormFill'
import { Uploader } from '../../Uploader'

export const FilePicker = ({ isRequired, validation, label, ...props }) => (
  <FormFill isRequired validation={validation} label={label}>
    <Uploader {...props} />
  </FormFill>
)
